import React, { forwardRef } from 'react';
import cx from 'classnames';

export type PressableProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * A clickable surface that draws its own look — a colour swatch, a figure, a list row, a slider dot.
 * It brings only the behaviour every one of them shares: `type="button"`, the focus ring and the
 * disabled cursor. An action that looks like a button is `Button`; an icon alone is `IconButton`.
 */
export const Pressable = forwardRef<HTMLButtonElement, PressableProps>(
  ({ type = 'button', className, ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cx(
        'cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  ),
);

Pressable.displayName = 'Pressable';
